import React from "react";
import {Navigate, useParams, useRoutes} from "react-router";
import AppPolicyMaker from "../apps/policymaker/AppPolicyMaker";
import {routesChat} from "./routesChat";
import ListOfIntelligenceRequirementsPage from "../apps/policymaker/pages/IR/list/ListOfIntelligenceRequirementsPage";
import ListOfPriorityIntelligenceRequirements
    from "../apps/policymaker/pages/PIR/list/ListOfPriorityIntelligenceRequirements";
import ListOfKeyIntelligenceQuestions from "../apps/policymaker/pages/KIQ/list/ListOfKeyIntelligenceQuestions";
import ListOfInformationCollectionRequests
    from "../apps/policymaker/pages/ICR/list/listOfInformationCollectionRequests";
import ListOfIntelligenceInformationReports
    from "../apps/policymaker/pages/IIR/list/ListOfIntelligenceInformationReports";
import ListOfFinishedIntelligence from "../apps/policymaker/pages/FINTEL/list/ListOfFinishedIntelligence";
import ListOfRawData from "../apps/policymaker/pages/RAW/list/ListOfRawData";
import PolicyPage from "../apps/policymaker/pages/policy/page/PolicyPage";
import ChatBody from "../apps/policymaker/components/chat/body/ChatBody";
import IntelligenceRequirementPage from "../apps/policymaker/pages/IR/page/IntelligenceRequirementPage";
import PIRPage from "../apps/policymaker/pages/PIR/page/PIRPage";
import IcrPage from "../apps/policymaker/pages/ICR/page/IcrPage";
import ListOfExperts from "../features/experts/ListOfExperts.jsx";
import ExpertPage from "../features/experts/ExpertPage";
import FeedsPage from "../features/chat/feeds/FeedsPage";
import FeedItems from "../features/chat/feeds/components/FeedItems";
import ReadbookPage from "../apps/policymaker/pages/readbooks/ReadbookPage";
import KnowledgeBasePage from "../features/knowledgeBase/KnowledgeBasePage";
import EntitiesList from "../features/knowledgeBase/EntitiesList";
import EntityDetailPage from "../features/knowledgeBase/EntityDetailPage";
import WhiteboardsListPage from "../features/whiteboards/WhiteboardsListPage";
import WhiteboardPage from "../features/whiteboards/WhiteboardPage";
import LegacyWhiteboardRedirect from "./LegacyWhiteboardRedirect";

function LegacyPolicymakerIcrRedirect() {
    const {icrId} = useParams();
    return <Navigate to={`/ICR/${encodeURIComponent(icrId || '')}`} replace/>;
}
import HelpPage from "../features/help/HelpPage";
import WorkflowPage from "../features/workflow/WorkflowPage";
import AllProductsPage from "../features/products/pages/AllProductsPage";

const routesPolicyMaker = [
    ...routesChat,
    {
        path: "/",
        element: <AppPolicyMaker/>,
        children: [
            {index: true, element: <Navigate to="policies" replace/>},
            {path: "IR", element: <ListOfIntelligenceRequirementsPage/>},
            {path: "PIR", element: <ListOfPriorityIntelligenceRequirements/>},
            {path: "KIQ", element: <ListOfKeyIntelligenceQuestions/>},
            {path: "ICR", element: <ListOfInformationCollectionRequests/>},
            {path: "RFI", element: <Navigate to="/ICR" replace/>},
            {path: "IIR", element: <ListOfIntelligenceInformationReports/>},
            {path: "FINTEL", element: <ListOfFinishedIntelligence/>},
            {path: "raw", element: <ListOfRawData/>},
            {path: "experts", element: <ListOfExperts/>},
            {path: "experts/:handle", element: <ExpertPage/>},
            {path: "charts", element: <WhiteboardsListPage/>},
            {
                path: "feed",
                element: <FeedsPage/>,
                children: [
                    {
                        path: ":feedId", element: <FeedItems/>,
                        children: [
                            {path: ":sourceSegmentId", element: <ReadbookPage/>},
                        ],
                    },],
            },
            {path: "help", element: <HelpPage/>},
            {path: "workflow", element: <WorkflowPage/>},
            {path: "products", element: <AllProductsPage/>},
            {
                path: "kb",
                element: <KnowledgeBasePage/>,
                children: [
                    {index: true, element: <EntitiesList/>},
                    {path: ":entityId", element: <EntityDetailPage/>},
                ],
            },
        ],
    },
    {
        path: "/policies/:policyId",
        // element: <ReportEditorPage/>,
        element: <PolicyPage/>,
        children: [
            {
                path: ":chatId", element: <ChatBody/>,
                children: [
                    {path: ":sourceSegmentId", element: <ChatBody/>},
                ],
            },
        ],
    },
    {
        path: "IR/:irId",
        element: <IntelligenceRequirementPage/>,
    },
    {
        path: "PIR/:pirId",
        element: <PIRPage/>,
    },
    {
        path: "ICR/:icrId",
        element: <IcrPage/>,
    },
    {
        path: "RFI/:icrId",
        element: <LegacyPolicymakerIcrRedirect/>,
    },
    {
        path: "/charts/:whiteboardId",
        element: <WhiteboardPage/>,
    },
    {path: "/whiteboards", element: <Navigate to="/charts" replace/>},
    {path: "/whiteboards/*", element: <LegacyWhiteboardRedirect/>},
    {path: "*", element: <Navigate to="/IR" replace/>},
];

export function RoutesPolicyMaker() {
    return useRoutes(routesPolicyMaker);
}